document.addEventListener('DOMContentLoaded', () => {
  class StepFeature extends HTMLElement {
    constructor() {
      super();
      this.carousel = this.querySelector("[data-carousel]");
      this.init();
    }

    init() {
      if (this.carousel != null) {
        this.initCarousel();
      }
    }

    initCarousel() {
      const splide = new Splide( this.carousel, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        lazyLoad : 'nearby',
        arrows : false,
        pagination : true,
        breakpoints: {
          767: {
            padding: {
              right: '20%'
            },
            gap: 8,
          },
        },
      } );
      
      splide.mount();
    }
  }

  if (!customElements.get("section-step")) {
    customElements.define("section-step", StepFeature);
  }
})
